export default __webpack_public_path__ + "static/media/generation_count.bb3c1e43.svg";